import { environment } from '@env/environment'
import * as L from 'leaflet'
import 'leaflet-draw'

export const MAX_GROSS_SURFACE_AREA_SQKM_CM = 16_000_000
export const MAX_GROSS_SURFACE_AREA_SQKM = 600_000
// @todo, France causes issue in the limitation of cm runnable surface area in NUTS, due to outer-see territories. This prevents running France + Finland but the NUTS0 geom for France is still the root issue for many bugs. It should be checked if we can replaced with a continental France geom
export const MAX_GROSS_SURFACE_AREA_SQKM_NUTS0 = 95_609_057
// export const CONSTANT_YEAR = 2012

export const APP_NAME = environment.appName
export const WIKI_URL = environment.wikiUrl
export const FEEDBACK = environment.feedback
export const API_URL = environment.apiUrl
export const INTEGRATION_SERVER_URL = environment.integrationServerUrl
export const KEYCLOAK_URL = environment.keycloakUrl
export const KEYCLOAK_REALM = environment.keycloakRealm
export const KEYCLOAK_CLIENT_ID = environment.keycloakClientId

export const PROJECT_CITIWATTS = 'citiwatts'
export const PROJECT_COOLLIFE = 'CoolLIFE'
export const PROJECT_SAPHEA = 'SAPHEA'
export const PROJECT_DECHETS_VS = 'DechetsVS'
export const PROJECT_OM4A = 'openMod4Africa'

export const MAP_OPTIONS = {
  zoomControl: false,
  center: L.latLng(environment.centerMap[0], environment.centerMap[1]),
  zoom: environment.zoom,
  minZoom: 4,
  maxZoom: 17,
  zoomAnimationThreshold: 3,
  layers: [],
}

// Angular docs recommands not using the component selector as the custom element tag name.
// see: https://angular.dev/guide/elements
export const POP_UP_DOM_ELEMENT_NAME = 'app-popup-geojson-dom-element'

// GeoServer
export const GEOSERVER_URL = environment.geoserverUrl + environment.geoserverWorkspace + 'wms'
export const GEOSERVER_URL_GEOJSON =
  environment.geoserverUrl + environment.geoserverWorkspace + 'ows'
export const URL_LEGEND =
  GEOSERVER_URL +
  '?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=50&HEIGHT=10&STRICT=false&style='
export const FORMAT_IMAGE = 'image/png8'
export const GEOSERVER_FEATURE_INFO_URL =
  GEOSERVER_URL +
  '?' +
  'SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&FORMAT=image/png&TRANSPARENT=true&QUERY_LAYERS=' +
  environment.prefixWorkspaceName

// Layer order number
/*
  More the number is big, more hight is the layer on the toolbox
*/

export const CSV_POINT_LAYER_ORDER = 6
export const SCALE_LAYER_ORDER = 5 //@TODO add automatically, now 5 is defined in each env
export const CM_LAYERS_ORDER = 4
export const PERSONAL_LAYERS_ORDER = 3
export const LAYERS_ORDER = 2
export const CSV_AREA_LAYER_ORDER = 1
export const MAPS_ORDER = 1

// For the integration platform
export const LAYER_CLONED_TYPES = ['Raster', 'Vector', 'Tabular', 'Unknown']
export const ADMIN_GEOM_TABLE_NAMES =
  environment.appName === PROJECT_OM4A
    ? ['boundaries0', 'boundaries1', 'regions']
    : ['nuts0', 'nuts1', 'nuts2', 'nuts3', 'lau2']
